module.exports = __webpack_public_path__ + "static/fonts/iconfont.79474d0.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.eot
// module id = nzd/
// module chunks = 1